import React from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/en-gb';
import useTranslate from '../customHooks/useTranslate';
import useLanguage from '../customHooks/useLanguage';
import { convertDateToDayjs, isMinValueDate } from '../utils/formatDates';

const DateInput = props => {
    const {
        labelText,
        errorMessage,
        required,
        onBlur,
        value,
        onChange,
        minDate,
        maxDate,
        ...restProps
    } = props;
    const { language } = useLanguage();

    // const mask = languageSettings[language].mask;

    const translatedErrorMessage = useTranslate(errorMessage);

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            key={language}
            adapterLocale={language}
        >
            <DatePicker
                label={labelText ? useTranslate(labelText) : undefined}
                slotProps={{
                    textField: {
                        size: 'small',
                        helperText: errorMessage
                            ? translatedErrorMessage
                            : undefined,
                        required: required,
                        error: !!errorMessage,
                        onBlur: (_e, newValue) => {
                            onBlur?.(
                                newValue && newValue.isValid()
                                    ? newValue.toDate()
                                    : null
                            );
                        },
                    },
                }}
                required={required}
                value={
                    value && !isMinValueDate(value)
                        ? convertDateToDayjs(value)
                        : null
                }
                onChange={newValue => {
                    // convert dayjs → Date
                    onChange?.(
                        newValue && newValue.isValid()
                            ? newValue.toDate()
                            : null
                    );
                }}
                minDate={minDate ? convertDateToDayjs(minDate) : undefined}
                maxDate={maxDate ? convertDateToDayjs(maxDate) : undefined}
                {...restProps}
            />
        </LocalizationProvider>
    );
};

export default DateInput;
